module.exports = __webpack_public_path__ + "fe311e2c4cd18901a1124f333044aafd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/mummy-hand.png
// module id = 2071
// module chunks = 0